























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Utils } from "@/service/util";
import { ElInput } from "element-ui/types/input";
@Component
export default class InputNumber extends Vue {
  @Prop() maxlength: number;
  @Prop() index: number;
  @Prop() value: number;
  @Prop() readonly: any;
  @Prop() disabled: any;
  @Prop() className: string;
  @Prop() styleInput: string;

  /**
   * mode number output
   * thousand  : デフォルト 3桁毎にカンマ区切り
   * digit     : 小数入力許可
   * padnumber : IDなどの処理 左ゼロ埋め
   */
  @Prop({ default: "thousand" })
  mode: string;

  /**
   * digit mode option 
   * maxDigi      : 小数点以下の桁数上限
   * maxNumLength : 整数部の桁数上限 -1で無効
   * naturalNum   : 小数点以下0の時に整数で表示する
   */
  @Prop({ default: 1 })
  maxDigi: number; // mode 'digit' must have maxDigi default 1
  @Prop({ default: -1 })
  maxNumLength: number;
  @Prop({ default: false })
  naturalNum: boolean; 


  @Prop() padnumber: number; // mode 'padnumber' zero prefix
  @Prop({ default: "medium" })
  size: string;
  @Prop() placeholder: string;

  @Prop({ default: false })
  autofocus: boolean;
  @Prop({ default: true })
  showZero!: boolean;
  @Prop({ default: false })
  dealZero!: boolean; // showZeroに加えて入力も0扱いを優先する
  @Prop({ default: 0 })
  fixedNegaPosi: number; // 入力結果の正負を指定する( -1:負数固定, 0:off, 1:正数固定 )

  public currentValue: any = null; // emitする数値
  public displayValue: any = "";   // el-input の v-model、カンマ区切りやゼロ埋めのため currentValue と分ける
  timerSelect: any = null;
  isEmit: boolean = false;

  isFocusing: boolean = false; // 入力操作中を判断するフラグ（onFocusでtrue、onBlurでfalse）
  
  // ipadのEnglishキーボードで入力上限が1文字少なくなる現象対策のコントロールフラグ
  // 共通処理だと一部環境でキー入力受信前に文字数上限Trueになり、先にgoNextInput()が動いてしまう
  blurFlg: boolean = false; 

  // inputのキー入力判定 (入力許可文字リスト)
  validKeys: any = [];
  vaildRegex: RegExp = new RegExp("");

  public utils: Utils = new Utils();

  $refs!: {
    input: ElInput;
  };

  @Watch("value")
  onValueChange(value: any, oldVal: any) {
    if (this.isEmit) {
      this.isEmit = false;
    } else {
      this.initValue(value);
    }
  }

  created() {
    this.initValue(this.value);
    // dealZeroはshowZeroの機能を内包する
    if ( this.dealZero ) { this.showZero = true; }
  }

  mounted() {
    setTimeout(() => {
      if (this.autofocus) {
        this.focus();
      }
    }, 100);
  }

  @Watch("maxDigi")
  @Watch("mode")
  @Watch("fixedNegaPosi")
  resetInputRules() {
    this.validKeys = [];
    this.vaildRegex = new RegExp("");
    if (!this.isFocusing) {
      this.initValue(this.value);
    }
  }

  formatValidKeys() {
    if (this.validKeys.length == 0) {
      let keys = [46, 8, 9, 27, 13, 92];
      if (this.mode === "digit" && this.maxDigi !== 0) { // 小数点の許可
        keys.push(110);
        keys.push(190);
      }
      if ( this.fixedNegaPosi <= 0 ) { // マイナス記号の許可
        keys.push(189);
        keys.push(109);
      }
      this.validKeys = keys;
      return keys;
    }
    return this.validKeys;
  }

  formatValidRegex() {
    if (this.vaildRegex.source == "" || this.vaildRegex.source == "(?:)") {
      let text = "0-9";
      if (this.mode === "digit" && this.maxDigi !== 0) { // 小数点の許可
        text += "\.";
      }
      if ( this.fixedNegaPosi <= 0 ) { // マイナス記号の許可
        text += "\-";
      }
      this.vaildRegex = new RegExp("[^" + text + "]","g");
      return this.vaildRegex;
    }
    return this.vaildRegex;
  }

  initValue(value: any) {
    // value の watcher が設定変更の watcher より先でも、現在の props で変換する。
    this.validKeys = [];
    this.vaildRegex = new RegExp("");
    if (value != null) {
      this.value = value;
      this.displayValue = this.value.toString();
      this.textToNumber();
      this.setCurrentValue(false);
      this.numberToText();
    } else {
      this.currentValue = null;
      this.displayValue = null;
      this.$nextTick(() => {
        this.displayValue = "";
      });
    }
  }

  textToNumber() {
    if (this.displayValue) {
      const input = this.mode === "digit" && this.maxDigi === 0
        ? this.displayValue.split(".")[0]
        : this.displayValue;
      const num = input
        .replace( this.formatValidRegex() , "") // 数値・小数点・負号のみ許可
        .replace(/(?!^)-/g, ""); // 先頭以外の負号は除去
      if (this.mode === "digit") {
        this.displayValue = num.replace(/(\..*)\./g, "$1");
      } else if (
        this.mode != "padnumber" &&
        this.mode != "digit" &&
        !this.dealZero &&
        this.currentValue != null
      ) {
        this.displayValue = num.replace(/^0+/g, "");
      }
    }
    // win(通常) : maxlength判定できるが、フォーカス時に誤動作する
    // ipad(English) : maxlength判定できる
    // →終了フラグで抑制をすることで動作を安定させる
    if (this.blurFlg && (this.displayValue.length >= +this.maxlength || this.isDecimalFull())) {
      this.goNextInput();
    }
  }

  // 小数が最大桁数まで入力されているか
  isDecimalFull(): boolean {
    return (this.mode == "digit" && this.displayValue.indexOf(".") > -1 &&
            this.displayValue.slice(this.displayValue.indexOf(".")).length > this.maxDigi);
  }

  numberToText() {
    if (isNaN(this.currentValue)) {
      this.currentValue = null;
      this.emitValue();
    }

    // 操作継続中はここから下の処理が不要
    if (this.isFocusing) {
      return;
    }

    if ( this.currentValue == null ) {
      if (this.showZero) {
        this.$nextTick(() => {
          if (this.mode === "digit" && !this.naturalNum && this.maxDigi > -1) {
            this.displayValue = (0).toFixed(this.maxDigi);
          } else if (!this.dealZero) {
            this.displayValue = "";
          } else {
            this.displayValue = "0";
          }
        });
      } else {
        this.$nextTick(() => {
          this.displayValue = "";
        });
      }
    } else if ( this.mode === "thousand" ) {
      if (this.currentValue == 0) {
        if (this.readonly || !this.showZero) {
          this.displayValue = "";
        } else {
          this.displayValue = "0";
        }
      } else {
        if ( this.fixedNegaPosi != 0 ) {
          let value = this.convNegaPosi(this.currentValue);// 正負固定
          if ( value != this.currentValue ) {
            this.currentValue = value;
            this.emitValue();
          }
        }
        let txt = this.currentValue
          .toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        this.displayValue = null;
        this.$nextTick(() => {
          this.displayValue = txt;
        });
      }
    } else if (this.mode === "digit" && this.maxDigi > -1) {
      if ( this.fixedNegaPosi != 0 ) {
        let value = this.convNegaPosi(this.currentValue);// 正負固定
        if ( value != this.currentValue ) {
          this.currentValue = value;
          this.emitValue();
        }
      }
      if (!this.naturalNum) {
        this.displayValue = this.currentValue.toFixed(this.maxDigi);
      } else {
        this.displayValue = parseFloat(this.currentValue).toString();
      }
    } else if (
      this.mode === "padnumber" &&
      this.padnumber &&
      +this.displayValue > 0
    ) {
      this.displayValue = this.displayValue.padStart(this.padnumber, "0");
    }

    // 誤差計測
    if (this.displayValue != null) {
      // win(通常) : maxlength判定できるが、フォーカス時に誤動作する
      // ipad(English) : maxlength判定できる
      // →終了フラグで抑制をすることで動作を安定させる
      if (this.blurFlg && (this.displayValue.length >= +this.maxlength || this.isDecimalFull())) {
        this.goNextInput();
      }
    }
  }

  // 数値を正負の範囲で固定する
  convNegaPosi( value: any ) {
    let num: any;
    if ( this.mode === "digit" ) { 
      num = Math.abs(value); 
    } else {
      num = Math.floor(Math.abs(Number(value)));
    }
    return this.fixedNegaPosi < 0 ? num * -1 : num;
  }


  onInput(e: any) {
    this.textToNumber();
    this.setCurrentValue();
    this.numberToText();
    this.$emit("onInput");
  }

  onKeypress(e: any) {
    e.target.value = e.target.value.replace(/．/g, '.');
    let el = document.activeElement as any;
    if (el.selectionStart != el.selectionEnd) {
      return true;
    } else if (this.maxNumLength > -1) {
      if (this.mode == "digit") {
        const isDecimalInput: boolean = (e.target.value.indexOf(".") > -1 &&
                                         e.target.value.indexOf(".") < el.selectionStart); // 入力箇所が小数点より右か
        if (
          e.target.value.split(".")[0].length >= this.maxNumLength &&
          (e.code.indexOf("Digit") > -1 ||
            (e.code.indexOf("NumpadDecimal") == -1 &&
              e.code.indexOf("Numpad") > -1)) &&
          !isDecimalInput
        ) {
          e.preventDefault();
        } else if (e.target.value.indexOf(".") > -1) {
          const arr = e.target.value.slice(e.target.value.indexOf("."));
          if (
            arr.length >= this.maxDigi &&
            (e.code.indexOf("Digit") > -1 || e.code.indexOf("Numpad") > -1)
          ) {
            this.blurFlg = true;
          }
        }
      }
    } else {
      let num = e.target.value;
      if (this.mode == "thousand") {
        num = num.replace(/^0+/g, "");
      }
      if (num.length >= +this.maxlength - 1) {
        // win(通常) : maxlength入力前に反応しmaxlength -1の条件を満たす
        // ipad(English) : 入力後に反応しmaxlength -1で1文字早く動く
        // →文字数の最低限の条件を満たしたので終了フラグを立てる
        this.blurFlg = true;
      }
    }
  }

  goNextInput() {
    this.blurFlg = false; // 終了フラグ再初期化
    setTimeout(() => {
      this.blur();
      this.utils.focusNext(this.index);
    }, 0);
  }

  setCurrentValue(doEmit: boolean = true) {
    const str = this.displayValue.replace(/,/g, "");
    this.currentValue = Number(str);
    if (this.dealZero && str == "") {
      this.currentValue = 0;
      this.displayValue = "0";
    } else if (isNaN(Number(str)) || str == "") {
      this.currentValue = null;
    } else {
      this.currentValue = Number(str);
    }
    if (doEmit) {
      this.emitValue();
    }
  }

  clearTimerSelect() {
    if (this.timerSelect) {
      clearTimeout(this.timerSelect);
      this.timerSelect = null;
    }
  }

  onEnter(e: any) {
    this.clearTimerSelect();
    this.goNextInput();
    this.$emit("onEnter", e);
  }

  onFocus() {
    this.isFocusing = true;
    this.clearTimerSelect();
    if (!this.readonly) {
      this.textToNumber();
      this.timerSelect = setTimeout(() => {
        this.$refs.input.select();
      }, 200);
    }
  }

  onBlur(event: any) {
    this.isFocusing = false;
    if (!this.readonly) {
      this.clearTimerSelect();
      if (event && event.target.value) {
        const patt = /[\uFF0B-\uFF5A]/g;
        let strInput = event.target.value;
        if (patt.test(strInput)) {
          // 全角を半角に変換
          strInput = this.utils.toASCII(strInput);
        }
        if (this.mode === "digit" && this.maxDigi === 0) {
          strInput = strInput.split(".")[0];
        }
        let num = parseFloat(strInput.replace( this.formatValidRegex() , ""));
        if (num != this.currentValue) {
          this.currentValue = !isNaN(num) ? num : 0;
          this.displayValue = strInput; // 全角半角変換した場合、表示の更新も必要
          this.emitValue();
        }
      }
      this.numberToText();
      if (this.mode == "padnumber") {
        this.emitValue();
      }
      this.$emit("focusout", this.currentValue);
    }
  }

  getValue() {
    return this.currentValue;
  }

  focus() {
    this.$refs.input.focus();
  }

  blur() {
    this.$refs.input.blur();
  }

  onChange(val: any) {
    this.$emit("change", this.currentValue);
  }

  emitValue() {
    if (!this.readonly && !this.disabled) {
      if (this.value == this.currentValue) {
        return;
      }
      this.isEmit = true;
      this.$emit(
        "input",
        this.mode == "padnumber" ? this.displayValue : this.currentValue
      );
    }
  }

  onKeydown(e: any) {
    if (
      this.formatValidKeys().indexOf(e.keyCode) !== -1 || // 主要なキー入力
      // Allow: Ctrl+A
      (e.keyCode == 65 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+C
      (e.keyCode == 67 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+X
      (e.keyCode == 88 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+V
      (e.keyCode == 86 && (e.ctrlKey || e.metaKey)) ||
      // Allow: home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39)
    ) {
      return;
    }

    // 通常の数値のみ許可
    if (
      (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
      (e.keyCode < 96 || (e.keyCode > 105 && e.keyCode)) // 109 key minus
    ) {
      e.preventDefault();
    }
  }
}
